import { Injectable } from '@angular/core';
import { ModulesManagerService } from '../classes/Module/modules-manager.service';
import { Filesystem, Directory, ReaddirResult, ReadFileResult, PermissionStatus, StatResult } from '@capacitor/filesystem';
import write_blob from 'capacitor-blob-writer';
import { Documents } from '../classes/Documents/documents';
import { PhotoViewerPage } from '../Modales/PhotoViewer/photo-viewer/photo-viewer.page';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';
import { LoggerService } from './logger.service';


@Injectable()

export class DocumentsService {
  private manager: ModulesManagerService;
  private appDirectory: Directory = Directory.External;
  private defautlPicture: string = "assets/pictures/loading.gif"
  private defautlBrokenPicture: string = "assets/pictures/broken.png"
  constructor() { }

  initiate(manager: ModulesManagerService) {
    this.manager = manager;
  }

  get DefautPicture() {
    return this.defautlPicture
  }

  get DefautBrokenPicture() {
    return this.defautlBrokenPicture
  }

  public async viewDocument(document: Documents) {
    await this.manager.displayModal({
      component: PhotoViewerPage,
      componentProps: {
        document
      },
      cssClass: "transparent-modal"
    })
  }

  private async hasPermission(): Promise<boolean> {
    let perm: PermissionStatus = await Filesystem.checkPermissions();
    let denied: PermissionState = 'denied'
    let grant: PermissionState = 'granted'
    let prompt: PermissionState = 'prompt'

    if (perm.publicStorage == grant) return true;

    if (perm.publicStorage == denied) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_NO_PERMISSION"));
      return false
    }
    if (perm.publicStorage == prompt) {
      await Filesystem.requestPermissions()
      return await this.hasPermission()
    }

  }

  async getFolder(folderFullPath: string, createIfNotFound: boolean = false): Promise<ReaddirResult> {
    if (!await this.hasPermission()) return;

    let result: ReaddirResult = await Filesystem.readdir({
      path: folderFullPath,
      directory: this.appDirectory
    }).catch((error) => {
      LoggerService.log("Document operation error:", error)
      return null
    });
    if (result == null) {
      if (createIfNotFound) {
        await Filesystem.mkdir({
          path: folderFullPath,
          directory: this.appDirectory
        })
        return await this.getFolder(folderFullPath, false)
      } else {
        this.manager.Tool.notify(this.manager.Trad.Parse("STR_NO_FOLDER_FOUND", { folder: folderFullPath }))
        return null;
      }
    } else
      return result as ReaddirResult
  }

  async deleteFile(fileFullPath: string) {
    if (!await this.hasPermission()) return;
    await Filesystem.deleteFile({
      path: fileFullPath,
      directory: this.appDirectory
    }).catch(e => {
      LoggerService.error("Document read error:", e)
    })
  }

  async deleteDirectory(fileFullPath: string) {
    if (!await this.hasPermission()) return;
    await Filesystem.rmdir({
      path: fileFullPath,
      directory: this.appDirectory,
      recursive: true
    }).catch(e => {
      LoggerService.error("Document read error:", e)
    })
  }

  async getFileInfo(fileFullPath: string, notifyMe: boolean = true): Promise<StatResult> {
    if (!await this.hasPermission()) return;
    let result: StatResult = await Filesystem.stat({
      path: fileFullPath,
      directory: this.appDirectory
    }).catch((error) => {
      LoggerService.debug('Erreur lors de la lecture du dossier', error)
      return null
    });
    if (result == null && notifyMe) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_NO_FILE_FOUND", { file: fileFullPath }))
    }
    return result as StatResult
  }

  async getFile(fileFullPath: string, notifyMe: boolean = true): Promise<ReadFileResult> {
    if (!await this.hasPermission()) return;
    let result: ReadFileResult = await Filesystem.readFile({
      path: fileFullPath,
      directory: this.appDirectory
    }).catch((error) => {
      LoggerService.log("Document operation error:", error)
      return null
    });
    if (result == null && notifyMe) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_NO_FILE_FOUND", { file: fileFullPath }))
    }
    return result as ReadFileResult
  }

  Base64ToBlob(b64Data, contentType): Blob {
    contentType = contentType || '';
    const sliceSize = 512;
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }



  async fileOpen(document: Documents) {
    if (this.manager.Tool.isPlatform('web')) {
      const obj = URL.createObjectURL(this.Base64ToBlob(document.PicturSrcV2, document.Mime));
      await this.manager.Navi.openLink(obj);
      URL.revokeObjectURL(obj);
      return;
    }

    const { uri } = await Filesystem.getUri({
      path: document.fullFilePath,
      directory: this.appDirectory,
    });

    await FileOpener.openFile({
      path: uri,
      mimeType: document.Mime,
    });
  }


  async writeFileFromB64(fileFullPath: string, fileName: string, base64: any, notifyMe: boolean = false): Promise<Boolean> {

    let folder = await this.getFolder(fileFullPath, true)
    if (folder == null) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_ERROR"))
      return false
    }
    let file: ReadFileResult = await this.getFile(fileFullPath + "/" + fileName, false)
    if (file != null) {
      if (notifyMe)
        this.manager.Tool.notify(this.manager.Trad.Parse("STR_FILE_ALLREADY_EXIST"))
      return false;
    }
    let splited = base64.split(";base64,")

    let created = true
    await write_blob({
      directory: this.appDirectory,
      path: fileFullPath + "/" + fileName,
      blob: this.Base64ToBlob(splited[1], splited[0].replace("data:", ""))
    }).catch((e) => {
      LoggerService.error("Document write error:", e)
      created = false
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_ERROR"))
    })

    return created
  }

  async writeFileFromBlob(fileFullPath: string, fileName: string, blob: any, notifyMe: boolean = false): Promise<Boolean> {
    let folder = await this.getFolder(fileFullPath, true)
    if (folder == null) {
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_ERROR"))
      return false
    }

    let file: ReadFileResult = await this.getFile(fileFullPath + "/" + fileName, false)
    if (file != null) {
      if (notifyMe)
        this.manager.Tool.notify(this.manager.Trad.Parse("STR_FILE_ALLREADY_EXIST"))
      return false;
    }

    let created = true
    await write_blob({
      directory: this.appDirectory,
      path: fileFullPath + "/" + fileName,
      blob: blob
    }).catch((e) => {
      LoggerService.error("Document write error:", e)
      created = false
      this.manager.Tool.notify(this.manager.Trad.Parse("STR_ERROR"))
    })

    return created
  }
}
